export const defaultTemplate = {
    name: "Default",
    base_font : 0,
    is_active : true,
    base_font_size: 14,
    favicon: "",
    share_image: "",
    email_header: "",
    link_init_colour: 0,
    link_init_style: 1,
    link_init_underline: false,
    link_hover_colour: 0,
    link_hover_style: 1,
    link_hover_underline: false,
    background_alt: "",
    background_tile: true,
    background_fixed: true,
    background_image: "",
    background_colour: 0,
    background_container_colour: 0,
    background_container_transparent: false,
    buttons: [],
    colours: [],
    fonts: [],
    gradients: [],
    texts: [],
    links: [],
}

